/* OSKA Recent Products Carousel — loop support for 2+ genuine viewed products.
   The extra cards are visual copies, not fabricated recommendations/history. */
(function(){
  'use strict';
  var CONFIG=[
    {selector:'[data-oska-global-recent]',track:'[data-oska-history-track]',buttons:'[data-oska-history-step]'},
    {selector:'[data-oska-recent-section]',track:'[data-oska-rec-rail]',buttons:'[data-oska-step]'},
    {selector:'#oska-recently-viewed',track:'#oska-recently-grid',buttons:'[data-oska-recent-step]'}
  ];
  function createLoop(root,config){
    var rail=root.querySelector(config.track);
    if(!rail||rail.dataset.oskaLoopMounted==='1')return;
    rail.dataset.oskaLoopMounted='1';
    var buttons=Array.from(root.querySelectorAll(config.buttons));
    var count=0,sideSets=0,step=0,locked=false,busy=false;
    var ticker=null,restartScroll=null;
    function originals(){return Array.from(rail.children).filter(function(el){return !el.hasAttribute('data-oska-loop-copy')})}
    function clone(item){
      var copy=item.cloneNode(true);
      copy.setAttribute('data-oska-loop-copy','true');
      copy.setAttribute('aria-hidden','true');
      copy.querySelectorAll('a,button,input,select,textarea,[tabindex]').forEach(function(el){el.tabIndex=-1});
      return copy;
    }
    function actualStep(){
      var child=rail.querySelector('.oska-global-recent__card,.oska-mb__rec-card,.oska-related-card');
      if(!child)return 0;
      var gap=parseFloat(getComputedStyle(rail).columnGap||getComputedStyle(rail).gap)||0;
      return child.getBoundingClientRect().width+gap;
    }
    function pulseControls(){
      // Original per-section arrow handlers use scroll position to determine disabled state.
      // Keep them in sync after the copies are inserted or recentered.
      rail.dispatchEvent(new Event('scroll'));
      if(count>1){buttons.forEach(function(b){b.disabled=false})}
    }
    function center(){
      if(count<2)return;
      step=actualStep();if(step<=0)return;
      var desired=sideSets*count*step;
      if(Math.abs(rail.scrollLeft-desired)>1){
        var snap=rail.style.scrollSnapType;
        rail.style.scrollSnapType='none';
        rail.scrollLeft=desired;
        rail.style.scrollSnapType=snap;
      }
      pulseControls();
    }
    function rebuild(){
      if(busy)return;
      // Sections not being shown yet have no measurable card width.
      if(root.hidden||rail.getBoundingClientRect().width<2)return;
      busy=true;
      var old=rail.querySelectorAll('[data-oska-loop-copy]');
      old.forEach(function(el){el.remove()});
      var base=originals();
      count=base.length;
      if(count<2){
        step=0;
        busy=false;
        buttons.forEach(function(b){b.disabled=true});
        return;
      }
      // Several complete copies on both sides guarantee movement even with
      // only two or four real history items and four cards visible.
      sideSets=Math.max(2,Math.ceil(5/count)+1);
      var fragBefore=document.createDocumentFragment(),fragAfter=document.createDocumentFragment();
      for(var s=0;s<sideSets;s++){
        base.forEach(function(item){fragBefore.appendChild(clone(item));fragAfter.appendChild(clone(item))});
      }
      rail.insertBefore(fragBefore,rail.firstChild);
      rail.appendChild(fragAfter);
      requestAnimationFrame(function(){center();busy=false});
    }
    function recenter(){
      if(!count||!step||busy||root.hidden)return;
      var position=rail.scrollLeft/step,lower=sideSets*count,upper=lower+count;
      if(position>=upper-.15||position<=lower-1+.15){
        var target=rail.scrollLeft;
        if(position>=upper-.15)target-=count*step;
        else if(position<=lower-1+.15)target+=count*step;
        var snap=rail.style.scrollSnapType;
        rail.style.scrollSnapType='none';
        rail.scrollLeft=target;
        rail.style.scrollSnapType=snap;
        pulseControls();
      }
    }
    function slide(direction){
      if(count<2||root.hidden||rail.getBoundingClientRect().width<2)return;
      var newStep=actualStep();
      if(newStep>0)step=newStep;
      if(!step)return;
      rail.scrollBy({left:direction*step,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
    }
    // Existing arrow handlers scroll normally; looping makes room so they work.
    // If the buttons were disabled before rendering, center() re-enables them.
    rail.addEventListener('scroll',function(){
      if(!count||busy)return;
      clearTimeout(restartScroll);
      restartScroll=setTimeout(recenter,180);
    },{passive:true});
    var observer=new MutationObserver(function(){
      if(busy)return;
      rebuild();
    });
    observer.observe(rail,{childList:true});
    if('ResizeObserver' in window){
      new ResizeObserver(function(){
        if(count<2){rebuild();return}
        var fresh=actualStep();
        if(fresh>0&&Math.abs(fresh-step)>1){step=fresh;center()}
      }).observe(rail);
    }
    function setAutoplay(){
      if(ticker)clearInterval(ticker);
      ticker=setInterval(function(){
        if(document.hidden||root.hidden||count<2||rail.matches(':hover')||rail.contains(document.activeElement)||matchMedia('(prefers-reduced-motion: reduce)').matches)return;
        slide(1);
      },3500);
    }
    buttons.forEach(function(b){
      b.addEventListener('click',function(){setAutoplay()});
    });
    document.addEventListener('visibilitychange',function(){if(!document.hidden)center()});
    setAutoplay();
    rebuild();
  }
  function mount(){
    CONFIG.forEach(function(config){
      document.querySelectorAll(config.selector).forEach(function(root){createLoop(root,config)})
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',mount,{once:true});
  else mount();
})();
